import { useEffect, useState } from "react";
import { projectFirestore } from "../firebase/config";

//custom hook pobiera na bierząco dane z firestore database collection 'images' z urlami zdjec
// collection = przekazany string  nazwy collection
const useFirestore = (collectionName) => {
  const [docs, setDocs] = useState([]); // url i timestamp ze zdjeciami

  useEffect(() => {
    //https://firebase.google.com/docs/firestore/query-data/listen
    //! onSnapshot uruchamia się ZA KAZDYM razem gdy w database nastąpią zmiany
    //.orderBy ( wg kolejnosci createdAt ) z collection 'images'

    // unsub zawiera funckje
    const unsub = projectFirestore
      .collection(collectionName)
      .orderBy("createdAt", "desc")
      .onSnapshot((snapshot) => {
        let documents = [];
        snapshot.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id }); // za pomocą spread zapisz wszystkie dane do array documents
        });
        setDocs(documents); // zapisz w state pobrane dane
      });
    // cleanup
    return () => unsub(); // zwracaj wywyołanie funkcji
  }, [collectionName]); // uruchamiaj funkcje gdy collectionName się zmieni

  return { docs };
};

export default useFirestore;
